document.addEventListener('DOMContentLoaded', () => {
    const applicationForm = document.querySelector('[id^="addressForm_kundenclubHandwerkerBewerbung"]') as HTMLFormElement | null;
    if (applicationForm) {
        const genderField = applicationForm.querySelector('select[name$="[singleselect-1]"]') as HTMLSelectElement | null;
        const firstNameField = applicationForm.querySelector('input[name$="[text-2]"]') as HTMLInputElement | null;
        const lastNameField = applicationForm.querySelector('input[name$="[text-3]"]') as HTMLInputElement | null;
        const companyField = applicationForm.querySelector('input[name$="[text-1]"]') as HTMLInputElement | null;
        const emailField = applicationForm.querySelector('input[name$="[email-1]"]') as HTMLInputElement | null;
        const phoneField = applicationForm.querySelector('input[name$="[telephone-1]"]') as HTMLInputElement | null;
        fetch('/api/form-prefill', {
            method: 'GET',
            credentials: 'same-origin',
        }).then(response => {
            if (response.ok) {
                return response.json().then(data => {
                    if (genderField) {
                        if (data.gender === 0) {
                            // Check for option with value male, Mr, Mr., Herr
                            const maleOption = Array.from(genderField.options).find(option => {
                                return option.value.toLowerCase() === 'male' || option.value.toLowerCase() === 'mr' || option.value.toLowerCase() === 'mr.' || option.value.toLowerCase() === 'herr';
                            })
                            if (maleOption) {
                                genderField.value = maleOption.value;
                            }
                        } else if (data.gender === 1) {
                            // Check for option with value female, Ms, Ms., Mrs, Mrs., Frau
                            const femaleOption = Array.from(genderField.options).find(option => {
                                return option.value.toLowerCase() === 'female' || option.value.toLowerCase() === 'ms' || option.value.toLowerCase() === 'ms.' || option.value.toLowerCase() === 'mrs' || option.value.toLowerCase() === 'mrs.' || option.value.toLowerCase() === 'frau';
                            })
                            if (femaleOption) {
                                genderField.value = femaleOption.value;
                            }
                        }
                    }

                    if (firstNameField) {
                        firstNameField.value = data.firstName || '';
                    }

                    if (lastNameField) {
                        lastNameField.value = data.lastName || '';
                    }

                    if (companyField) {
                        companyField.value = data.company || '';
                    }

                    if (emailField) {
                        emailField.value = data.email || '';
                    }

                    if (phoneField) {
                        phoneField.value = data.phone || '';
                    }
                });
            }
        })
    }
})
